/**
 * @description 車輛排氣量單位用
*/
export enum VehiclePowerType {
    /** 立方公分 */
    CubicCm = 'CC',
    /** 馬力 */
    Hp = 'HP'
}

/**
 * @description 車輛排氣量單位-中文名稱用
*/
export enum VehiclePowerTypeText {
    /** C.C. 數 */
    CubicCm = 'CC數',
    /** 馬力 */
    Hp = '馬力'
}
